import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
		tracesSampleRate: 0.1,
	});
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);

// PWA를 나중에 다시 켜려면 register()로 되돌리면 됩니다.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

